import { useState, useEffect } from "react";
import axios from "axios";
import { Image as ImageIcon } from "lucide-react";

/**
 * Hook to load an image URL that requires Authorization header,
 * converting the response into a blob URL usable by <img>.
 */
export function useAuthImage(url, token) {
  const [blobUrl, setBlobUrl] = useState(null);

  useEffect(() => {
    if (!url || !token) {
      setBlobUrl(null);
      return;
    }

    let cancelled = false;
    let objectUrl = null;

    axios
      .get(url, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob",
      })
      .then((response) => {
        if (!cancelled) {
          objectUrl = URL.createObjectURL(response.data);
          setBlobUrl(objectUrl);
        }
      })
      .catch(() => {
        if (!cancelled) setBlobUrl(null);
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url, token]);

  return blobUrl;
}

/**
 * Image component that loads via Authorization header.
 * Renders a placeholder while loading or on error.
 */
export function AuthImage({ src, alt, className, token }) {
  const blobUrl = useAuthImage(src, token);

  if (!blobUrl) {
    return (
      <div className={`${className} bg-slate-100 flex items-center justify-center`}>
        <ImageIcon className="w-8 h-8 text-slate-300" />
      </div>
    );
  }

  return <img src={blobUrl} alt={alt} className={className} />;
}
